// Slug helpers with no dependencies, so proxy.ts can use them as well as the app

// URL slug derived from a title, e.g. "Oracle APEX Development" -> "oracle-apex-development"
export function toSlug(title: string) {
  return title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')
}

// Services with a dedicated page use their `slug`; the rest fall back to the title-based slug
export function getServiceHref(service: { title: string; slug?: string }) {
  return `/services/${service.slug || toSlug(service.title)}`
}
